import { Tabs, TabsList, TabsTrigger } from "@repo/ui/components/ui/tabs";
import { createFileRoute, Outlet, useMatchRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/catalog/_layout")({
  component: RouteComponent,
});

const TABS = [
  { value: "procedures", label: "Procedures", to: "/catalog/procedures" },
  { value: "exams", label: "Exams", to: "/catalog/exams" },
  { value: "questionnaires", label: "Questionnaires", to: "/catalog/questionnaires" },
  { value: "performance-measures", label: "Performance measures", to: "/catalog/performance-measures" },
  { value: "devices", label: "Devices", to: "/catalog/devices" },
  { value: "locations", label: "Locations", to: "/catalog/locations" },
] as const;

function RouteComponent() {
  const navigate = useNavigate();
  const matchRoute = useMatchRoute();

  const activeTab = TABS.find((t) => matchRoute({ to: t.to, fuzzy: true }))?.value ?? "procedures";

  return (
    <div className="flex h-full min-h-0 flex-col">
      <Tabs value={activeTab} className="border-b bg-background">
        <TabsList variant={"line"}>
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} onClick={() => navigate({ to: t.to })}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <div className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>
  );
}
